(function() {
  'use strict';

  angular
    .module('triumphLookbooks', ['ngAnimate', 'ngTouch', 'ngSanitize', 'ngAria', 'ngRoute', 'ionic', 'hj.imagesLoaded']);

    //inject config
	angular.element(document).ready(function() {

			var initInjector = angular.injector(['ng']);
			var $http = initInjector.get('$http');

			//get the lookbook config 
			$http.get('assets/data/lookbook-config.json').then(
				function (response) {
					// create app config constant
					angular.module('triumphLookbooks')
						.constant('appData', response.data);
					// bootstrap app
					angular.bootstrap(document, ['triumphLookbooks']);
				});
			});
})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

// (function() {
//   'use strict';

//   angular
//     .module('triumphLookbooks')
//     .directive('introSlide', [function () {
//   /** @ngInject */
//       return {
//         templateUrl: 'app/components/introSlide/introSlide.html',
//         scope: {
//             mode:"@",
//             collection:"@"

//         },
//         controller: IntroSlideController,
//         controllerAs: 'intro',
//         bindToController: true
//       };
    
//     }])

//     .controller('IntroSlideController', [function ($scope, $element, $attrs, $log, introData) {

//       var vm = this;
//     console.log(introData);


// }]);
(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .directive('autoHeight', autoHeight);

  /** @ngInject */
  function autoHeight() {
    var directive = {
      link: linkFunc,
      controller: autoHeightController,
      controllerAs: 'annotationText',
      bindToController: true
    };

    return directive;

    function linkFunc(scope, el, attrs, vm) {
      
      // when browser is resized
      scope.$on('resize::resize', function() {
        setElementHeight();
      });
      // when images have loaded
      scope.$on('imagesLoaded::imagesLoaded', function() {
        setElementHeight();
      });

      function setElementHeight(){
        attrs.$set('style', 'height: 0px;');
        setTimeout(function(){
          var sliderHeight = document.getElementById('ionSlide').clientHeight;
          attrs.$set('style', 'height:' + sliderHeight + 'px;');
        }, 20);
        
      }
    }

    /** @ngInject */
    function autoHeightController() {
      var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .directive('contacts', contacts);

  /** @ngInject */
  function contacts() {
    var directive = {
      templateUrl: 'app/components/contacts/contacts.html',
      scope: {
          pageContacts: '@',
          contactsStyle: '@',
          image: '@',
          mode: '@'

      },
      controller: ContactsController,
      controllerAs: 'contacts',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ContactsController(appData) {
      var vm = this;

      vm.frame = JSON.parse(vm.pageContacts);
      vm.contacts = vm.frame.contacts;
      vm.containerSize;
      vm.mediaContactsText;
      vm.showFooter = vm.frame.showFooterMessage;
      vm.contactIndex = vm.frame.contactsIndex;
      vm.imageUrl = "";


      vm.showFooter = function(){
        if (vm.frame.showFooterMessage == true)
        {
          return true;
        } else {
          return false;
        }
      };

      vm.showImage = function(){
        console.log("testing image: "+ vm.image);
        // if image equals false then return false else true
        if (vm.image == false){
          return false;
        } else {
          vm.imageUrl = vm.image;
          return true;
        }
      };
       
      if (vm.contacts.length <= 2){
        vm.containerSize = "small";
      } else {
        vm.containerSize = "large";
      }

      if (appData.activeCollection == 'essence' || appData.activeCollection == 'florale' ){
        // different formatting for triaction header
        //vm.mediaContactsText = "Media Contacts </span class=\"triaction-index\">" + vm.contactIndex + "</span>";
        if (window.currentMode == 'large'){
            vm.mediaContactsText = "Media Contacts";
        }
        if (window.currentMode == 'mobile'){
            vm.mediaContactsText = "Media Contacts </span class=\"triaction-index\">(" + vm.contactIndex + "):</span>";
        }

      } else if (appData.activeCollection == 'triaction') {

        if (window.currentMode == 'large'){
            vm.mediaContactsText = "Media Contact";
        }
        if (window.currentMode == 'mobile'){
            vm.mediaContactsText = "Media Contact </span class=\"triaction-index\">(" + vm.contactIndex + "):</span>";
        }
        
      } else {
        // if there's more than two elements make the text plural
        if (vm.contacts.length >= 2){
          // if the frame has indexing enabled insert that to (eg. 1/3 etc)
          if (vm.frame.contactsIndexEnable){
            vm.mediaContactsText = "Media Contacts (" + vm.contactIndex + "):";
          } else {
            // other wise just dont include indexing
            vm.mediaContactsText = "Media Contacts:";
          }
        } else {
          // don't even consider indexing as we only have two or less contacts
          vm.mediaContactsText = "Media Contact:";
        }
      }    
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('triumphLookbooks')
      .service('collections', collections);

  /** @ngInject */
  function collections($log, $http, appData) {
    
    var vm = this;
    vm.filename;
    vm.urlbase = "assets/data/collections/";

    vm.getCollection = function(collectionName, localised, region) {
      
      // if the requested collection is localised
      if (localised) {
        // build the localised filename
        vm.filename = collectionName + "/" + collectionName + "-" + region;

      } else {
        if (appData.activeCollectionLocalised == true){
          // build a non localised filename
          vm.filename = collectionName + "/" + collectionName + "-" + appData.defaultRegion;

        } else {
          vm.filename = collectionName + "/" + collectionName;

        }
        
      }

      return $http.get(vm.urlbase + vm.filename + '.json');
    }

    

  }

})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .directive('annotationText', annotationText);

  /** @ngInject */
  function annotationText() {
    var directive = {
      templateUrl: 'app/components/annotationText/annotationText.html',
      scope: {
          title: '@',
          description: '@',
          position: '@',
          color: '@'
      },
      controller: AnnotationTextController,
      controllerAs: 'annotationText',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AnnotationTextController() {
      var vm = this;


    }
  }

})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .directive('annotationHover', annotationHover);

  /** @ngInject */
  function annotationHover() {
    var directive = {
      templateUrl: 'app/components/annotationHover/annotationHover.html',
      controller: AnnotationHoverController,
      controllerAs: 'annotationHover',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AnnotationHoverController() {
      var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .controller('LookbookController', LookbookController);

  /** @ngInject */
  function LookbookController($timeout, appData, $location, $window, $log, collections, $ionicSlideBoxDelegate, $document, $rootScope, $scope) {
    
    var vm = this;
    // variable to hold locale
    vm.region;
    // global app configuration holding chosen collection
    vm.appData = appData;
    // store the data for the active collection
    vm.collection;
    // handle page resizing
    vm.oldWidth = $window.innerWidth;
    // current mode
    vm.currentMode;
    // current slide index
    vm.slideIndex = 0;
    // current slide data
    vm.currentSlide;
    // current slide height
    vm.currentSliderHeight;
    // intro loaded
    vm.introLoaded = false;
    // stores the current pages image download links
    vm.pageLinks = [];
    // dev mode
    vm.devMode = true;
    // holds number of desktop contact pages
    vm.numberOfDesktopContactPages = 0;
    // current desktop pages
    vm.currentDesktopPage = 1;
    // first contact page id
    vm.contactPageId;
    // stores a merged array of all desktop contacts
    vm.desktopContacts = [];
    // store desktop contact pages
    vm.desktopContactPages = [];

    // handle browser width detection
    vm.updateWidth = function( ) {
      // initial setting of character div height;
      var w = $window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth;
      // set new width 
      vm.newWidth = x;
      // select mobile / desktop mode  
      if (vm.newWidth >= 768)
      {
        if (vm.currentMode == "mobile"){
          vm.slideIndex = 0;
        }
        // set desktop mode
        vm.currentMode = "large";
        $window.currentMode = "large";
        $ionicSlideBoxDelegate.enableSlide([false]);
      } else {
        if (vm.currentMode == "large"){
          vm.slideIndex = 0;
        }
        // set mobile mode
        vm.currentMode = "mobile";
        $window.currentMode = "mobile";
        
        $ionicSlideBoxDelegate.enableSlide([true]);
        // store height of slider to fix slide heights for no image panels      
      }   
    };

    // Determines if we need to check for locales 
    vm.initialise = function() {
      // add resize handler for home page character imagery
      angular.element( $window ).on('resize', function () {
        vm.newWidth = $window.innerWidth;
        vm.updateWidthTimer;
      // if the width has not chchanged
      if (vm.newWidth !== vm.oldWidth) {
        $timeout.cancel(vm.updateWidthTimer);
      }
      vm.updateWidthTimer = $timeout(function() {
        vm.updateWidth();
        $scope.$broadcast('resize::resize');
        
      }, 100);
    });
    // set the chosen collection
    vm.activeCollectionName = vm.appData.activeCollection;
    // get browser width
    vm.updateWidth();
    // add bg class to body
    $rootScope.bodyBg = vm.activeCollectionName + '-bg';
      // check from appdata to see if this collection has multiple regions enabled.
      if (vm.appData.activeCollectionLocalised) {
        // check the url for region paramter
        vm.regionParameter = $location.search().region;
        // check this parameter exists in our app config
        if (vm.appData.regions.indexOf(vm.regionParameter) > -1) {
          // we recognise this locale so set it 
          vm.region = vm.regionParameter;
          $log.debug("Region set to: " + vm.regionParameter);
        } else {
          // A valid parameter hasn't been supplied so use the default
          vm.region = vm.appData.defaultRegion;
          $log.debug("Defaulting to: " + vm.appData.defaultRegion)
        }
        // load the collection localised region
        collections.getCollection(vm.activeCollectionName, true, vm.region)
        .success(function (collection) {
            vm.collection = collection;
            // continue setting up the page
            vm.setupPage();
        })
        .error(function (error) {
            $log.debug("error");
        });
      } else {

        // load the collection we need without localisation
        collections.getCollection(vm.activeCollectionName, false)
        .success(function (collection) {

            vm.collection = collection;
            // continue setting up the page
            vm.setupPage();
            // store intro data as a constant
            angular.module('triumphLookbooks')
            .constant('introData', collection.intro);
        })
        .error(function (error) {
        });
      }
    };

    vm.setupPage = function() {
      if (vm.activeCollectionName != 'triaction'){
        // create mobile json
        vm.createMobileJson();
      }
      
      // set title tag
      $window.document.title = vm.collection.collectionBrowserTitle;
      // init the currentslide
      vm.currentSlide = vm.collection[vm.currentMode][vm.slideIndex];
      
      

      // returns true if slider is on the last slide
      vm.isLastSlide = function(){
        var len;
        if (vm.currentMode === "mobile") {
          len = vm.collection.mobile.length;
        } else if (vm.currentMode === "large") {
          len = vm.collection.large.length;
        }
        if (vm.slideIndex == (len - 1) ) {
          return true;  
        }
        return false;
      };

      if (vm.activeCollectionName != 'triaction'){
        // setup contact pages
        vm.setupContact();
      }
  
    };

    vm.clone = function(object) {
      var cloned = Object.create(object.prototype || null);
      Object.keys(object).map(function (i) {
          cloned[i] = object[i];
      });
   
      return cloned;
    };

    // test function to create desktop data from mobile slides - test to save population time
    vm.createMobileJson = function() {
      vm.mobileGenerateIndex = 1;
      vm.generatedMobileCollection = [];
      vm.mobileImageGenIndex = 0;
      //get desktop object
      var col = vm.collection.large;
      // create mobile array
      vm.mobileCollection = [];
      // count the number of desktop contact pages and extract all contacts into one array, also take push
      for (var i = 0; i < vm.collection.large.length; i++){
        if (vm.collection.large[i].type == "contact"){
          vm.numberOfDesktopContactPages++;
          var currentPageContacts = vm.collection.large[i].contacts;
          vm.desktopContactPages.push(vm.collection.large[i]);
          Array.prototype.push.apply(vm.desktopContacts, currentPageContacts);
        }
      }
      // sort desktop contacts by id order
      vm.desktopContacts.sort(function(obj1, obj2) {
        // Ascending: first age less than the previous
        return obj1.id - obj2.id;
      });
       console.group("after sort")
       console.log(vm.desktopContacts)
       console.groupEnd();
      // loop through
      for (var i = 0; i < col.length; i++) {
        // determine double or single column
        if (col[i].type == 'double-column'){
          //console.log("Double column:" + col[i].type);
          // loop through double column and create two new mobile entries
          vm.buildMobileEntry(col[i].leftColumn);
          vm.buildMobileEntry(col[i].rightColumn);
        } else {
          vm.buildMobileEntry(col[i]);
        }
      }

      vm.buildMobileContactPages();
      vm.collection.mobile = vm.clone(vm.generatedMobileCollection);
    };

    vm.buildMobileEntry = function(desktopEntry){
      // new object
      var obj = {};
      
      vm.mobileImageGenId = 0;

      // current etry
      var ent = desktopEntry;

      // type conversion

      // core specific
      if (ent.type == 'image-text-full-width' && vm.activeCollectionName == 'core'){
        obj.type = "text";
      }
      // general
      if (ent.type == 'full-width-image'){
        obj.type = 'image';
      }
      if (ent.type == 'image'){
        obj.type = 'image';
      }
      if (ent.type == 'double-image'){
        obj.type = 'double-image';
      }
      if (ent.type == 'text'){
        obj.type = 'text';
      }
      if (ent.type == 'intro'){
        obj.type = 'intro';
      }

      if (ent.type != 'double-image') {

        // styling
        if (ent.hasOwnProperty('border') && ent.border.length > 0){
          //console.log('has border prop: ' + ent.border)
          obj.border = ent.border;
        }
        if (ent.hasOwnProperty('positioning') && ent.positioning.length > 0){
          //console.log('has positioning prop: ' + ent.positioning)
          obj.positioning = ent.positioning;
        }
        if (ent.hasOwnProperty('annotationEnabled') && ent.annotationEnabled == true || false){
          //console.log('has annotationEnabled prop: ' + ent.annotationEnabled)
          obj.annotationEnabled = ent.annotationEnabled;
        }
        if (ent.hasOwnProperty('annotationPositionMobile') && ent.annotationPositionMobile.length > 0){
          //console.log('has annotationPosition prop: ' + ent.annotationPosition)
          obj.annotationPosition = ent.annotationPositionMobile;
        }
        if (ent.hasOwnProperty('backgroundColor') && ent.backgroundColor.length > 0){
          //console.log('has backgroundColor prop: ' + ent.backgroundColor)
          obj.backgroundColor = ent.backgroundColor;
        }
        if (ent.hasOwnProperty('text') && ent.text.length > 0){
          //console.log('has text prop: ' + ent.text)
          obj.text = ent.text;
        }
        if (ent.hasOwnProperty('backgroundDesign') && ent.backgroundDesign.length > 0){
          //console.log('has backgroundDesign prop: ' + ent.backgroundDesign)
          obj.backgroundDesign = ent.backgroundDesign;
        }
        if (ent.hasOwnProperty('productTitle') && ent.productTitle.length > 0){
          //console.log('has productTitle prop: ' + ent.productTitle)
          obj.productTitle = ent.productTitle;
        }
        if (ent.hasOwnProperty('productDescription') && ent.productDescription.length > 0){
          //console.log('has productDescription prop: ' + ent.productDescription)
          obj.productDescription = ent.productDescription;
        }

        if (ent.hasOwnProperty('productDescription') && ent.productDescription.length > 0){
          //console.log('has productDescription prop: ' + ent.productDescription)
          obj.productDescription = ent.productDescription;
        }
      }

      // CHECK FOR UNDEFINED REGION HERE
      var region = vm.region || 'ukus';

      // image names
      if (ent.hasOwnProperty('imageName') && ent.imageName.length > 0 && ent.type != 'double-image'){
        //console.log('has imageName prop: ' + ent.imageName)
        // add one to image index
        vm.mobileImageGenIndex++
        // naming logic
        obj.imageName = vm.activeCollectionName + '_' + region + '_mobile_' + vm.mobileImageGenIndex + '.jpg';
      } 
      else if (ent.type == 'double-image') {
        // add one to image index
        vm.mobileImageGenIndex++

        
        // assume mobile filenames 
        var imageFilename = vm.activeCollectionName + '_' + region + '_mobile_' + vm.mobileImageGenIndex;
        // overide desktop image filenames
        var mobileImage1Name = imageFilename + '_1.jpg';
        var mobileImage2Name = imageFilename + '_2.jpg';
        obj = vm.clone(ent);
        // copy entire desktop object
        obj.image1Name = mobileImage1Name;
        obj.image2Name = mobileImage2Name;
      }
      obj.id = vm.mobileGenerateIndex++;


      if (ent.type != 'contact'){
        // add this object to new array
        vm.generatedMobileCollection.push(obj);
      }
      
    
    };

    vm.buildMobileContactPages = function(){
      //console.log("pushing new mobile contacts")
      //console.log(" there are " + vm.desktopContacts.length + "desktop contacts")

      // we need to seperate into pages of two contacts per contact page
      var mobileContactPageLength = Math.ceil(vm.desktopContacts.length / vm.collection.mobileContactsPerPage);
     
      //console.log("need to make " + mobileContactPageLength + " seperate pages for mobile contact page")
      // array to hold new contact pages
      var contactPages = [];
      // array of complete desktop contacts
      var desktopContacts = vm.desktopContacts;
      // loop and create each mobile page
      for (var i = 0; i < mobileContactPageLength; i++){

        // clone the contact page for this page
        var page = vm.clone(vm.desktopContactPages[0]);

        // last contact page
        if (i == mobileContactPageLength-1){
          page.showFooterMessage = true;
          page.findTheOneText = vm.collection.findTheOneText;
        }

        if (vm.collection.contactsIndexEnabled) {
          page.contactsIndexEnabled = true;
          page.contactsIndex = (i+1) + "\/" + mobileContactPageLength;
        } else {
          page.contactsIndexEnabled = false;
        }

        contactPages.push(page);
        // empty the contacts array
        contactPages[i].contacts = [];
        // if there are two left take them 
        if (desktopContacts.length >= vm.collection.mobileContactsPerPage){
          contactPages[i].contacts = desktopContacts.splice(0, vm.collection.mobileContactsPerPage);
          console.info("created page")
        } else {
          contactPages[i].contacts = desktopContacts;
          console.info("created last page")
        }
      }
      // then we push our new contacts pages to the array. applying them to merge
      Array.prototype.push.apply(vm.generatedMobileCollection, contactPages);

    };

    // slider logic

    // back to first slide
    vm.restart = function() {
      $ionicSlideBoxDelegate.slide(0, 500);
    };

    vm.updateSlider = function () {
      $ionicSlideBoxDelegate.update();
    };

    // check for SVG support
    vm.svgasimg = function() {
  
      if (vm.activeCollectionName == "florale"){
        return false;
      } else {
        return document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1");
      }
    };

    vm.nextSlide = function() {
      $ionicSlideBoxDelegate.next();
    };

    vm.previousSlide = function() {
      $ionicSlideBoxDelegate.previous();
    };

    // Called each time the slide changes
    vm.slideChanged = function(index) {
      // set the new page index
      vm.slideIndex = index;
      // update the current slide
      vm.currentSlide = vm.collection[vm.currentMode][vm.slideIndex];
      if (index > 0) {
        vm.tl.pause();
      }
      if (index == 0) {
        vm.tl.restart();
      }
      if (index == 6) {
        $scope.$broadcast('resize::resize');
      }
      vm.getDownloadImageLinks();
    };
    // load events for intro animation
    vm.imgLoadedEvents = {

        done: function(instance) {
            vm.setupIntro();
            vm.introLoaded = true;
            $scope.$broadcast('imagesLoaded::imagesLoaded');
        }
    };

    vm.sliderImgLoadedEvents = {

      always: function(instance) {
       
      },

      done: function(instance) {

          //angular.element(instance.elements[0]).addClass('loaded');
      },

      fail: function(instance) {
        
      }
      
    };

    vm.setupIntro = function() {
       
      // preloader element
      vm.preloader = document.getElementById('preloader');
      
      if( appData.activeCollection == "florale"){
        vm.tl = new TimelineLite({paused: true, repeat: 0, delay: 0});
        // when all images for core intro have loaded hide the preloader
        TweenLite.to("#preloader", 1, {autoAlpha:0, ease:Power2.easeOut, onComplete: vm.animateFloraleIntro});
      }
      if( appData.activeCollection == "essence"){
        vm.tl = new TimelineLite({paused: true, repeat: 0, delay: 0});
        // when all images for core intro have loaded hide the preloader
        TweenLite.to("#preloader", 1, {autoAlpha:0, ease:Power2.easeOut, onComplete: vm.animateEssenceIntro});
      }
      if( appData.activeCollection == "core"){
        vm.tl = new TimelineLite({paused: true, repeat: 0, delay: 0});
        // when all images for core intro have loaded hide the preloader
        TweenLite.to("#preloader", 1, {autoAlpha:0, ease:Power2.easeOut, onComplete: vm.animateCoreIntro});
      }
      if( appData.activeCollection == "triaction"){
        vm.tl = new TimelineLite({paused: true, repeat: 0, repeatDelay:0, delay: 1});
        // when all images for core intro have loaded hide the preloader
        TweenLite.to("#preloader", 1, {autoAlpha:0, ease:Power2.easeOut, onComplete: vm.animateTriactionIntro});
      }
    };


    vm.animateCoreIntro = function() {
      //create time line for core intro
      vm.tl
      .fromTo("#intro-1", 0, {autoAlpha:1}, {autoAlpha:0, onStart: vm.showMainText }, "0.4")
      .fromTo("#intro-2", 0, {autoAlpha:1}, {autoAlpha:0}, "0.7")
      .fromTo("#intro-3", 0, {autoAlpha:1}, {autoAlpha:0}, "1")
      .fromTo("#intro-4", 0, {autoAlpha:1}, {autoAlpha:0}, "1.3")
      .fromTo("#intro-5", 0, {autoAlpha:1}, {autoAlpha:0}, "1.6")
      .fromTo("#intro-6", 0, {autoAlpha:1}, {autoAlpha:0}, "1.9")
      .fromTo("#intro-7", 0, {autoAlpha:1}, {autoAlpha:0}, "2.2")
      .fromTo("#intro-8", 0, {autoAlpha:1}, {autoAlpha:0}, "2.5")
      .fromTo("#intro-9", 0, {autoAlpha:1}, {autoAlpha:0}, "2.8")
      .fromTo("#intro-10", 0, {autoAlpha:1}, {autoAlpha:0}, "3.1")
      .fromTo("#intro-11", 0, {autoAlpha:1}, {autoAlpha:0}, "3.4")
      .fromTo("#intro-12", 0, {autoAlpha:1}, {autoAlpha:0}, "3.7")
      .fromTo("#intro-13", 0, {autoAlpha:1}, {autoAlpha:0}, "4")
      .fromTo("#intro-14", 0, {autoAlpha:1}, {autoAlpha:0}, "4.3")
      .fromTo("#intro-15", 0, {autoAlpha:1}, {autoAlpha:0}, "4.6")
      .fromTo("#intro-16", 0, {autoAlpha:1}, {autoAlpha:0, onComplete: vm.showEndText }, "4.9")
      .fromTo("#intro-17", 0, {autoAlpha:1}, {autoAlpha:1, delay: 1 }, "5.2");
      vm.tl.play();
    };

     vm.animateTriactionIntro = function() {
      //create time line for core intro
      vm.tl
      .fromTo("#intro-1", 0, {autoAlpha:1}, {autoAlpha:0 }, "0.3")
      .fromTo("#intro-2", 0, {autoAlpha:1}, {autoAlpha:0}, "0.6")
      .fromTo("#intro-3", 0, {autoAlpha:1}, {autoAlpha:0}, "0.9")
      .fromTo("#intro-4", 0, {autoAlpha:1}, {autoAlpha:0}, "1.2")
      .fromTo("#intro-5", 0, {autoAlpha:1}, {autoAlpha:0}, "1.5")
      .fromTo("#intro-6", 0, {autoAlpha:1}, {autoAlpha:0}, "1.8")
      .fromTo("#intro-7", 0, {autoAlpha:1}, {autoAlpha:0}, "2.1")
      .fromTo("#intro-8", 0, {autoAlpha:1}, {autoAlpha:0}, "2.4")
      .fromTo("#intro-9", 0, {autoAlpha:1}, {autoAlpha:0}, "2.7")
      .fromTo("#intro-10", 0, {autoAlpha:1}, {autoAlpha:0}, "3")
      .fromTo("#intro-11", 0, {autoAlpha:1}, {autoAlpha:0}, "3.3")
      .fromTo("#intro-12", 0, {autoAlpha:1}, {autoAlpha:0}, "3.6")
      .fromTo("#intro-13", 0, {autoAlpha:1}, {autoAlpha:0}, "3.9")
      .fromTo("#intro-14", 0, {autoAlpha:1}, {autoAlpha:0}, "4.2")
      .fromTo("#intro-15", 0, {autoAlpha:1}, {autoAlpha:0}, "4.5")
      .fromTo("#intro-16", 0, {autoAlpha:1}, {autoAlpha:0}, "4.8")
      .fromTo("#intro-17", 0, {autoAlpha:1}, {autoAlpha:0}, "5.1")
      .fromTo("#intro-18", 0, {autoAlpha:1}, {autoAlpha:0}, "4.4")
      .fromTo("#intro-19", 0, {autoAlpha:1}, {autoAlpha:0}, "4.7")
      .fromTo("#intro-20", 0, {autoAlpha:1}, {autoAlpha:0, onComplete: vm.triactionAnimationFinished}, "4.8");
      vm.tl.play();
    };

    vm.animateEssenceIntro = function() {
      var fadeTime = 1.5;
      vm.tl
      .to("#main-text", 0, {autoAlpha:1},  "0")
      .to("#end-text", 0, {autoAlpha:0},  "0")
      .to("#intro-2", 0, {autoAlpha:1},  "0")
      .to("#intro-3", 0, {autoAlpha:0},  "0")
      .to("#intro-4", 0, {autoAlpha:0},  "0")
      .to("#intro-5", 0, {autoAlpha:0},  "0")

      .to("#intro-2", fadeTime, {autoAlpha:0},  "2")
      .to("#intro-3", fadeTime, {autoAlpha:1}, "2.5")
      .to("#intro-3", fadeTime, {autoAlpha:0}, "5")
      .to("#intro-4", fadeTime, {autoAlpha:1}, "5.5")
      .to("#intro-4", fadeTime, {autoAlpha:0, onStart: vm.showEssenceEndText }, "8")
      .to("#intro-5", fadeTime, {autoAlpha:1}, "8.5");
      vm.tl.play();
    };

    vm.animateFloraleIntro = function() {
      var fadeTime = 1.5;
      vm.tl
      .to("#main-text", 0, {autoAlpha:1},  "0")
      .to("#end-text", 0, {autoAlpha:0},  "0")
      .to("#intro-2", 0, {autoAlpha:1},  "0")
      .to("#intro-3", 0, {autoAlpha:0},  "0")
      .to("#intro-4", 0, {autoAlpha:0},  "0")

      .to("#intro-2", fadeTime, {autoAlpha:0},  "2")
      .to("#intro-3", fadeTime, {autoAlpha:1}, "2.75")
      .to("#intro-3", fadeTime, {autoAlpha:0, onStart: vm.showEssenceEndText }, "5")
      .to("#intro-4", fadeTime, {autoAlpha:1}, "5.75");
      vm.tl.play();
    };

    vm.triactionAnimationFinished = function (){
      $ionicSlideBoxDelegate.next();
    };

    vm.showMainText = function(){
      TweenLite.to("#main-text", 0, {autoAlpha:1}); 
      TweenLite.to("#end-text", 0, {autoAlpha:0});
    };

    vm.showEndText = function(){
      TweenLite.to("#main-text", 0, {autoAlpha:0});
      TweenLite.to("#end-text", 0, {autoAlpha:1});
    };

    vm.showEssenceMainText = function(){
      TweenLite.to("#main-text", 0, {autoAlpha:1});
      TweenLite.to("#end-text", 0, {autoAlpha:0});
    };

    vm.showEssenceEndText = function(){
      TweenLite.to("#main-text", 1.4, {autoAlpha:0});
      TweenLite.to("#end-text", 1.4, {autoAlpha:1});
    };

    vm.getContactImage = function(index){
      var currentPageIndex = index;
      var contactFrameImageEnabled;
      if (vm.currentMode == 'large'){
        contactFrameImageEnabled = vm.collection.large[currentPageIndex].imageEnabled;
        if (contactFrameImageEnabled == false){
          return false;
        } else if (contactFrameImageEnabled == true) {
          return vm.collection.collectionImagesBaseUrl + (vm.appData.activeCollectionLocalised === true ? vm.region + '/' : '') + vm.collection.largeImagesBaseUrl + vm.collection.large[currentPageIndex].imageName;
        } 
      } 
      if (vm.currentMode == 'mobile'){  
        contactFrameImageEnabled = vm.collection.mobile[currentPageIndex].imageEnabled;
        if (contactFrameImageEnabled == false){
          return false;
        } else if (contactFrameImageEnabled == true) {
          return vm.collection.collectionImagesBaseUrl + (vm.appData.activeCollectionLocalised === true ? vm.region + '/' : '') + vm.collection.mobileImagesBaseUrl + vm.collection.mobile[currentPageIndex].imageName;
        }   
      }  
    };

    vm.getDownloadImageLinks = function(){
      vm.pageLinks = [];
      vm.slideData = {};
      // based on mobile or desktop gather all images
      if (vm.currentMode == 'mobile'){
        // get the current slide
        vm.slideData = vm.collection.mobile[vm.slideIndex];
        // send slide data to get the images filename
        vm.getImageFilename(vm.slideData);
      } else {
        vm.slideData = vm.collection.large[vm.slideIndex];
        if (vm.slideData.type == 'double-column'){
          console.log(vm.slideData.leftColumn)
          // send both column to retrieve name 
          vm.getImageFilename(vm.slideData.leftColumn);
          vm.getImageFilename(vm.slideData.rightColumn);
        } else {
          vm.getImageFilename(vm.slideData);
        }
      }
      return vm.pageLinks;
    };

    vm.getImageFilename = function(slideData){
      var baseurl = vm.collection.collectionImagesBaseUrl + (vm.appData.activeCollectionLocalised === true ? vm.region + '/' : '') + (vm.currentMode === 'large' ? vm.collection.largeImagesBaseUrl : vm.collection.mobileImagesBaseUrl);
      var image = {};
      // if single image frame types
      if (slideData.type == 'image' || slideData.type == 'image-text-full-width' || slideData.type == 'full-width-image'){
        image = {};
        image.url = baseurl + slideData.imageName;  
        image.title = slideData.productTitle = slideData.productTitle || 'download';
        // add image to array to use in lookbook tempalte
        vm.pageLinks.push(image)  
      } 
      else if (slideData.type == 'double-image'){
        // do the same but with two images
        var image1 = {};
        image1.url = baseurl + slideData.image1Name;  
        image1.title = slideData.product1Title;
        var image2 = {};
        image2.url = baseurl + slideData.image2Name;  
        image2.title = slideData.product2Title;
        vm.pageLinks.push(image1, image2);
      } else {
        // if page type isn't matched empty array
        vm.pageLinks = [];
      }
    };
    
    //contact pages
    vm.setupContact = function() {
      // get contact object 
      vm.contacts = vm.collection.contacts;
    };



    // initialise the lookbook
    vm.initialise();
  }
})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

  }

})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .config(routeConfig);

  function routeConfig($routeProvider, $locationProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/lookbook/lookbook.html',
        controller: 'LookbookController',
        controllerAs: 'lookbook'
      })
      .otherwise({
        redirectTo: '/'
      });
    // use the HTML5 History API
    $locationProvider.html5Mode({
      enabled: true
    });

  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('triumphLookbooks')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
  }

})();

angular.module("triumphLookbooks").run(["$templateCache", function($templateCache) {$templateCache.put("app/lookbook/lookbook.html","<div class=\"container {{lookbook.appData.activeCollection}}\" style=\"width:100%; height:100%\"><header><div class=logo-wrapper ng-click=lookbook.restart()><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollection}}{{ lookbook.svgasimg() === true ? \'.svg\' : \'.png\' }}\" alt=\"Triumph Lingerie\" style=\"width: 100%\"></div></header><div class=lookbook__wrapper><!-- SLIDER CONTROLS --><div class=controls ng-if=\"lookbook.currentMode == \'large\'\"><!-- <div ng-if=\"lookbook.currentMode === \'large\'\" class=\"controls__left-panel\" ng-click=\"lookbook.previousSlide()\"></div>\n			<div ng-if=\"lookbook.currentMode === \'large\'\" class=\"controls__right-panel\" ng-click=\"lookbook.nextSlide()\"></div> --><div class=controls__previous-arrow ng-show=\"lookbook.slideIndex > 0\" ng-click=lookbook.previousSlide()><span class=icon-chevron-thin-left></span></div><div class=controls__next-arrow ng-click=lookbook.nextSlide()><span class=icon-chevron-thin-right ng-hide=lookbook.isLastSlide()></span></div></div><!-- MOBILE DESIGN --><ion-slide-box id=ionSlide ng-if=\"lookbook.currentMode === \'mobile\'\" on-slide-changed=lookbook.slideChanged(index)><ion-slide ng-repeat=\"frame in lookbook.collection.mobile\" ng-init=lookbook.updateSlider()><div class=\"single-column {{ frame.backgroundColor }}\"><!-- Start mobile Intro --><div ng-if=\"frame.type == \'intro\'\" class=\"images-loaded intro\" images-loaded-events=lookbook.imgLoadedEvents><div ng-repeat=\"image in lookbook.collection.intro.images\" class=intro__image><img id=intro-{{image.imageName}} ng-src={{lookbook.collection.intro.config.introImagesMobileBaseUrl}}{{image.imageName}}{{image.fileType}}></div><div id=preloader class=preloader><img ng-src={{lookbook.collection.intro.config.introPreloaderUrl}}></div><div id=main-text ng-if=\"lookbook.collection.intro.config.mainTextEnabled == true\"><img ng-src={{lookbook.collection.intro.config.introImagesMobileBaseUrl}}{{lookbook.collection.intro.config.mainTextSrc}}></div><div id=end-text ng-if=\"lookbook.collection.intro.config.endTextEnabled == true\"><img ng-src={{lookbook.collection.intro.config.introImagesMobileBaseUrl}}{{lookbook.collection.intro.config.endTextSrc}}></div></div><!-- End mobile Intro --><div ng-if=\"frame.backgroundColor == \'grey-white-vertical\' || frame.backgroundColor == \'pink-white-horizontal\' || frame.backgroundColor == \'grey-white-vertical-left\'\" class=\"{{ frame.backgroundColor }}-child\"></div><div ng-if=\"frame.type == \'image\'\" class=\"single-column__image-wrapper {{ frame.positioning }} {{ frame.border }}\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.mobileImagesBaseUrl }}{{ frame.imageName }}\" alt={{frame.productDescription}}></div><div ng-if=\"frame.type == \'image-text-full-width\'\" class=\"{{ frame.positioning }} {{ frame.backgroundColor }}\"><p ng-bind-html=frame.text class=\"single-text {{ frame.positioning }}\"></p><img ng-if=\"frame.imageEnabled == true\" ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.mobileImagesBaseUrl }}{{ frame.imageName }}\" alt=\"\"></div><div ng-if=\"frame.type == \'text\'\" auto-height class=\"background-wrapper {{ frame.positioning }} {{ frame.backgroundColor }}\"><p ng-bind-html=frame.text class=\"single-text {{ frame.positioning }}\"></p></div><div ng-if=\"frame.type == \'double-image\'\" class=double-image><!-- <annotation-text ng-if=\"frame.annotation1Enabled == true\" class=\"annotation-text {{ frame.annotation1Position }}\" title=\"{{ frame.product1Title }}\" description=\"{{ frame.product1Description}}\"></annotation-text> --><div class=\"right-column__image-wrapper {{ frame.image1Positioning }} {{ frame.image1Border }} multi-image\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.mobileImagesBaseUrl }}{{ frame.image1Name }}\" alt={{frame.product1Description}} style=\"max-width: 100%\" class=\"{{ frame.image1Border }}\"><annotation-hover class=\"annotation {{ frame.annotationBgColor }}\" ng-if=\"frame.annotation1Enabled == true\"></annotation-hover></div><!-- <annotation-text ng-if=\"frame.annotation2Enabled == true\" class=\"annotation-text {{ frame.annotation2Position }}\" title=\"{{ frame.product2Title }}\" description=\"{{ frame.product2Description}}\"></annotation-text> --><div class=\"right-column__image-wrapper {{ frame.image2Positioning }} {{ frame.image2Border }}\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.mobileImagesBaseUrl }}{{ frame.image2Name }}\" alt={{frame.product2Description}} style=\"max-width: 100%\" class=\"{{ frame.image2Border }}\"><annotation-hover class=\"annotation {{ frame.annotationBgColor }}\" ng-if=\"frame.annotation1Enabled == true\"></annotation-hover></div></div><!-- DOUBLE FRAME END --><contacts ng-if=\"frame.type == \'contact\'\" auto-height page-contacts=\"{{ frame }}\" image={{lookbook.getContactImage($index)}} mode=\"{{ lookbook.currentMode }}\" class=\"contacts background-wrapper {{ frame.positioning }} {{ frame.backgroundColor }} {{ frame.layout }}\"></contacts><!-- CONTACTS END --></div></ion-slide></ion-slide-box><!-- END MOBILE DESIGN --><div class=mobile-annotation ng-if=\"lookbook.currentMode === \'mobile\' && lookbook.currentSlide.annotationEnabled\"><div ng-if=\"lookbook.currentSlide.annotationEnabled && lookbook.currentSlide.type != \'double-image\'\"><h1 class=annotation__title ng-bind-html=lookbook.currentSlide.productTitle></h1><h2 class=annotation__description ng-bind-html=lookbook.currentSlide.productDescription></h2></div><div ng-if=\"lookbook.currentSlide.type == \'double-image\'\"><h1 class=annotation__title ng-bind-html=lookbook.currentSlide.product1Title></h1><h2 class=annotation__description ng-bind-html=lookbook.currentSlide.product1Description></h2><h2 class=annotation__description>&amp;</h2><h1 class=annotation__title ng-if=\"lookbook.currentSlide.product1Title != lookbook.currentSlide.product2Title\" ng-bind-html=lookbook.currentSlide.product2Title style=\"margin-top: 0\"></h1><h2 class=annotation__description ng-bind-html=lookbook.currentSlide.product2Description></h2></div></div><!-- LARGE DESIGN --><ion-slide-box id=ionSlide ng-if=\"lookbook.currentMode === \'large\'\" on-slide-changed=lookbook.slideChanged(index) ng-class=\"{\'hidden\':lookbook.slideIndex < 1}\"><ion-slide ng-repeat=\"frame in lookbook.collection.large\" ng-init=lookbook.updateSlider() class=ion__slide><div ng-if=\"frame.type == \'double-column\'\" class=double-column style=\"pointer-events: auto\"><div class=\"double-column__left-column {{ frame.leftColumn.backgroundColor }}\" ng-class=\"{active: hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"><annotation-text ng-if=\"frame.leftColumn.annotationEnabled == true\" class=\"annotation-text {{ frame.leftColumn.annotationPosition }} {{ frame.leftColumn.positioning }}\" title=\"{{ frame.leftColumn.productTitle }}\" description=\"{{ frame.leftColumn.productDescription}}\"></annotation-text><div ng-if=\"frame.leftColumn.backgroundColor == \'grey-white-vertical\' || frame.leftColumn.backgroundColor == \'pink-white-horizontal\' || frame.leftColumn.backgroundColor == \'grey-white-vertical-left\'\" class=\"{{ frame.leftColumn.backgroundColor }}-child\"></div><div ng-if=\"frame.leftColumn.type == \'image\'\" class=\"left-column__image-wrapper {{ frame.leftColumn.positioning }} {{ frame.leftColumn.border }}\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.leftColumn.imageName }}\" alt={{frame.productDescription}} style=\"max-width: 100%\" class=\"{{ frame.leftColumn.border }}\"><annotation-hover class=\"annotation {{ frame.leftColumn.annotationBgColor }}\" ng-if=\"frame.leftColumn.annotationEnabled == true\"></annotation-hover></div><div ng-if=\"frame.leftColumn.type == \'double-image\'\" class=double-image><annotation-text ng-if=\"frame.leftColumn.annotationEnabled == true\" class=\"annotation-text {{ frame.leftColumn.annotation1Position }}\" title=\"{{ frame.leftColumn.product1Title }}\" description=\"{{ frame.leftColumn.product1Description}}\"></annotation-text><div class=\"left-column__image-wrapper {{ frame.leftColumn.image1Positioning }} {{ frame.leftColumn.image1Border }} multi-image\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.leftColumn.image1Name }}\" alt={{frame.leftColumn.product1Description}} style=\"max-width: 100%\" class=\"{{ frame.leftColumn.image1Border }}\"><annotation-hover class=\"annotation {{ frame.leftColumn.annotationBgColor }}\" ng-if=\"frame.leftColumn.annotationEnabled == true\"></annotation-hover></div><annotation-text ng-if=\"frame.leftColumn.annotationEnabled == true\" class=\"annotation-text {{ frame.leftColumn.annotation2Position }}\" title=\"{{ frame.leftColumn.product2Title }}\" description=\"{{ frame.leftColumn.product2Description}}\"></annotation-text><div class=\"left-column__image-wrapper {{ frame.leftColumn.image2Positioning }} {{ frame.leftColumn.image2Border }}\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.leftColumn.image2Name }}\" alt={{frame.leftColumn.product2Description}} style=\"max-width: 100%\" class=\"{{ frame.leftColumn.image2Border }}\"><annotation-hover class=\"annotation {{ frame.leftColumn.annotationBgColor }}\" ng-if=\"frame.leftColumn.annotationEnabled == true\"></annotation-hover></div></div><div ng-if=\"frame.leftColumn.type == \'text\'\" class=\"background-wrapper {{ frame.leftColumn.positioning }} {{ frame.leftColumn.backgroundColor }}\"><p ng-bind-html=frame.leftColumn.text class=\"single-text {{ frame.leftColumn.positioning }}\"></p></div></div><div class=\"double-column__right-column {{ frame.rightColumn.backgroundColor }}\" ng-class=\"{active: hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"><annotation-text ng-if=\"frame.rightColumn.annotationEnabled == true\" class=\"annotation-text {{ frame.rightColumn.annotationPosition }} {{ frame.rightColumn.positioning }}\" title=\"{{ frame.rightColumn.productTitle }}\" description=\"{{ frame.rightColumn.productDescription}}\"></annotation-text><div ng-if=\"frame.rightColumn.backgroundColor == \'grey-white-vertical\' || frame.rightColumn.backgroundColor == \'pink-white-horizontal\' || frame.rightColumn.backgroundColor == \'grey-white-vertical-left\'\" class=\"{{ frame.rightColumn.backgroundColor }}-child\"></div><div ng-if=\"frame.rightColumn.type == \'image\'\" class=\"right-column__image-wrapper {{ frame.rightColumn.positioning }} {{ frame.rightColumn.border }}\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.rightColumn.imageName }}\" alt={{frame.productDescription}} style=\"max-width: 100%\" class=\"{{ frame.rightColumn.border }}\"><annotation-hover class=\"annotation {{ frame.rightColumn.annotationBgColor }}\" ng-if=\"frame.rightColumn.annotationEnabled == true\"></annotation-hover></div><div ng-if=\"frame.rightColumn.type == \'double-image\'\" class=double-image><annotation-text ng-if=\"frame.rightColumn.annotationEnabled == true\" class=\"annotation-text {{ frame.rightColumn.annotation1Position }}\" title=\"{{ frame.rightColumn.product1Title }}\" description=\"{{ frame.rightColumn.product1Description}}\"></annotation-text><div class=\"right-column__image-wrapper {{ frame.rightColumn.image1Positioning }} {{ frame.rightColumn.image1Border }} multi-image\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.rightColumn.image1Name }}\" alt={{frame.rightColumn.product1Description}} style=\"max-width: 100%\" class=\"{{ frame.rightColumn.image1Border }}\"><annotation-hover class=\"annotation {{ frame.rightColumn.annotationBgColor }}\" ng-if=\"frame.rightColumn.annotationEnabled == true\"></annotation-hover></div><annotation-text ng-if=\"frame.rightColumn.annotationEnabled == true\" class=\"annotation-text {{ frame.rightColumn.annotation2Position }}\" title=\"{{ frame.rightColumn.product2Title }}\" description=\"{{ frame.rightColumn.product2Description}}\"></annotation-text><div class=\"right-column__image-wrapper {{ frame.rightColumn.image2Positioning }} {{ frame.rightColumn.image2Border }}\"><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.rightColumn.image2Name }}\" alt={{frame.rightColumn.product2Description}} style=\"max-width: 100%\" class=\"{{ frame.rightColumn.image2Border }}\"><annotation-hover class=\"annotation {{ frame.rightColumn.annotationBgColor }}\" ng-if=\"frame.rightColumn.annotationEnabled == true\"></annotation-hover></div></div><div ng-if=\"frame.rightColumn.type == \'text\'\" class=\"background-wrapper {{ frame.rightColumn.positioning }} {{ frame.leftColumn.backgroundColor }}\"><p ng-bind-html=frame.rightColumn.text class=\"single-text {{ frame.rightColumn.positioning }}\"></p></div></div></div><!-- END DOUBLE COLUMN LAYOUT --><!-- START LARGE INTRO --><div ng-if=\"frame.type == \'intro\'\" class=\"images-loaded intro\" images-loaded-events=lookbook.imgLoadedEvents><div ng-repeat=\"image in lookbook.collection.intro.images\" class=intro__image><img id=intro-{{image.imageName}} ng-src=\"{{ lookbook.collection.intro.config.introImagesLargeBaseUrl}}{{image.imageName}}{{image.fileType}}\"></div><div id=preloader class=preloader><img ng-src={{lookbook.collection.intro.config.introPreloaderUrl}}></div><div id=main-text ng-if=\"lookbook.collection.intro.config.mainTextEnabled == true\"><img ng-src={{lookbook.collection.intro.config.introImagesLargeBaseUrl}}{{lookbook.collection.intro.config.mainTextSrc}}></div><div id=end-text ng-if=\"lookbook.collection.intro.config.endTextEnabled == true\"><img ng-src={{lookbook.collection.intro.config.introImagesLargeBaseUrl}}{{lookbook.collection.intro.config.endTextSrc}}></div><p ng-if=\"frame.textEnabled == true\" ng-bind-html=frame.text class=\"single-text {{ frame.positioning }}\"></p></div><!-- END LARGE INTRO --><!-- CONTACTS --><contacts ng-if=\"frame.type == \'contact\'\" auto-height page-contacts=\"{{ frame }}\" image={{lookbook.getContactImage($index)}} class=\"contacts background-wrapper {{ frame.positioning }} {{ frame.backgroundColor }} {{ frame.layout }}\"></contacts><!-- CONTACTS END --><!-- FULL WIDTH IMAGE BEGIN --><div ng-if=\"frame.type == \'full-width-image\'\" class=full-width-image ng-class=\"{active: hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"><annotation-text ng-if=\"frame.annotationEnabled == true && frame.multiAnnotationEnabled != true\" class=\"annotation-text {{ frame.annotationPosition }} {{ frame.positioning }}\" title=\"{{ frame.productTitle }}\" description=\"{{ frame.productDescription}}\" position=\"{{ frame.positioning }}\"></annotation-text><annotation-text ng-if=\"frame.annotation1Enabled == true && frame.multiAnnotationEnabled == true\" class=annotation-text title=\"{{ frame.product1Title }}\" color={{frame.anno1TextColor}} description=\"{{ frame.product1Description}}\" position=\"{{ frame.annotation1Position }}\"></annotation-text><annotation-text ng-if=\"frame.annotation2Enabled == true && frame.multiAnnotationEnabled == true\" class=annotation-text title=\"{{ frame.product2Title }}\" color={{frame.anno2TextColor}} description=\"{{ frame.product2Description}}\" position=\"{{ frame.annotation2Position }}\"></annotation-text><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.imageName }}\" alt={{frame.productDescription}} style=\"max-width: 100%\"><annotation-hover class=\"annotation {{ frame.annotationBgColor }}{{ frame.hoverImageEnabled ? \'image-hover \' + frame.hoverImageClass:\'\'}}\" ng-if=\"frame.annotationEnabled == true || frame.multiAnnotationEnabled == true\"></annotation-hover></div><div ng-if=\"frame.type == \'image-text-full-width\'\" class=image-text-full-width><p ng-bind-html=frame.text class=\"single-text {{ frame.positioning }}\"></p><img ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.largeImagesBaseUrl }}{{ frame.imageName }}\" alt={{frame.productDescription}} style=\"max-width: 100%\"></div></ion-slide></ion-slide-box></div><img ng-if=\"frame.imageEnabled == true\" ng-src=\"{{ lookbook.collection.collectionImagesBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.mobileImagesBaseUrl }}{{ frame.imageName }}\" alt=\"\" style=\"min-width: 100%\"><footer class=footer><div ng-if=\"lookbook.pageLinks.length > 0\"><h2 class=download-heading>Download Image</h2><a class=\"footer__link link--download\" ng-repeat=\"pic in lookbook.pageLinks\" download=\"{{ pic.title }}\" target=_blank href={{pic.url}}>{{$index+1}}</a></div><div><a href=\"{{ lookbook.collection.collectionPdfDownloadBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.collectionEmailPdfFilename }}\" download target=_blank ng-bind-html=lookbook.appData.downloadCollectionPdfEmailText class=\"footer__link link-pdf\"></a> <span class=divider>|</span> <a href=\"{{ lookbook.collection.collectionPdfDownloadBaseUrl }}{{ lookbook.appData.activeCollectionLocalised === true ? lookbook.region + \'/\' : \'\' }}{{ lookbook.collection.collectionPrintPdfFilename }}\" download target=_blank class=\"footer__link link-pdf\" ng-bind-html=lookbook.appData.downloadCollectionPdfPrintText></a></div></footer></div>");
$templateCache.put("app/components/annotationHover/annotationHover.html","");
$templateCache.put("app/components/annotationText/annotationText.html","<div class=\"annotation__text-wrapper {{ annotationText.position }}\"><h1 class=\"annotation__title {{ annotationText.color }}\" ng-bind-html=annotationText.title></h1><h2 class=\"annotation__description {{ annotationText.color }}\" ng-bind-html=annotationText.description></h2></div>");
$templateCache.put("app/components/contacts/contacts.html","<div class=\"contacts__wrapper {{ contacts.containerSize }}\"><div class=contacts__heading-wrapper><h1 ng-bind-html=contacts.mediaContactsText class=contacts__heading></h1></div><div class=contacts__container><div ng-repeat=\"person in contacts.contacts\" class=\"contacts__contact {{ contacts.containerSize }}\" itemscope itemtype=http://schema.org/Person><h2 ng-bind-html=person.country class=contacts__country></h2><h3 ng-bind-html=person.name class=contacts__name></h3><a class=contacts__tel href=tel:{{person.tel}} itemprop=telephone>{{person.tel}}</a> <a class=contacts__email href=mailto:{{person.email}} itemprop=email>{{person.email}}</a> <a ng-if=\"person.email2 != null\" class=contacts__email href=mailto:{{person.email}} itemprop=email>{{person.email2}}</a><div class=contacts__social><a ng-repeat=\"social in person.social\" href={{social.account.url}} target=_blank class=contacts__social-link><span class=icon-{{social.account.name}}></span> <span ng-if=social.account.label class=contacts__icon-label>{{social.account.label}}</span></a></div></div></div><div class=contacts__footer-wrapper ng-if=\"contacts.frame.showFooterMessage == true\"><h1 ng-bind-html=contacts.frame.findTheOneText class=contacts__footer-text></h1></div></div><img class=contacts__background ng-src={{contacts.imageUrl}} ng-if=contacts.showImage>");
$templateCache.put("app/components/introSlide/introSlide.html","<div class=single-column><div class=single-column__image-wrapper><div class=preloader><!-- <img src=\"\"> --> {{lookbook.intro.config.introPreloaderUrl}}</div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=navbar><a href=https://github.com/Swiip/generator-gulp-angular>Gulp Angular</a><ul><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=acme-navbar-text><li>Application was created {{ vm.relativeDate }}.</li></ul></nav>");}]);